export interface PlayerProgress {
  player_id: number;
  player_name: string;
  player_nickname: string;
  progress_percentage: number;
  label_count: number;
  task_count: number;
  total_tasks: number;
  score: number;
  iaa: number;
  is_active: boolean;
}

export interface GameSessionInfo {
  id: number;
  name: string;
  status: string;
  start_date: string;
  team_name: string;
}

export interface PlayerProgressSummary {
  total_players: number;
  active_players: number;
  average_progress: number;
  total_labels: number;
  total_tasks_completed: number;
  total_invites_sent: number;
  total_invites_accepted: number;
}

export interface PlayerProgressResponse {
  data: {
    game_session: GameSessionInfo;
    players: PlayerProgress[];
    summary: PlayerProgressSummary;
  };
}
